/**
 * 计算内核（crates/core wasm）的统一初始化入口。
 *
 * 多个引擎模块共用同一个 wasm 实例（魔棒、重采样…），初始化只能发生一次；
 * 各模块自己 init 会在测试里互相踩（initSync 重复调用）。
 */
import initWasm, { initSync } from '../wasm/core/photosmith_core';

let ready: Promise<unknown> | null = null;

/** 浏览器路径：按需异步初始化（Vite 提供产物 URL）。 */
export function ensureKernel(): Promise<unknown> {
  ready ??= initWasm();
  return ready;
}

/** 测试/Node 路径：用已编译模块同步初始化。重复调用是无操作。 */
export function initKernelSync(module: WebAssembly.Module): void {
  if (ready !== null) return;
  initSync({ module });
  ready = Promise.resolve();
}
